import React from "react";
import { useTranslation } from "react-i18next";
import { useRetrieveCurrentPlanzone } from "@planzone/view-models";
import { UseCases } from "@planzone/core";
import { Safeguard } from "@scenes/safeguard";
import { Button } from "@common/button";
import { useModal } from "@root/client/modal";
import { Props } from "./types";
import styles from "./styles.scss";

function Placeholder(props: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { pushView } = useModal();

  return (
    <div className={styles.placeholder}>
      <p>{t("zones.zonesPlaceholder")}</p>
      <Safeguard useCases={[UseCases.createZone]}>
        {({ canCreateZone }) =>
          canCreateZone && (
            <Button
              className={styles.button}
              press={() =>
                pushView({ key: UseCases.createZone, data: planzone })
              }
            >
              {t("zones.addZone")}
            </Button>
          )
        }
      </Safeguard>
    </div>
  );
}

export { Placeholder };
